import { render, staticRenderFns } from "./DataPlots.vue?vue&type=template&id=3befa4c5&scoped=true&"
import script from "./DataPlots.vue?vue&type=script&lang=js&"
export * from "./DataPlots.vue?vue&type=script&lang=js&"
import style0 from "./DataPlots.vue?vue&type=style&index=0&id=3befa4c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3befa4c5",
  null
  
)

export default component.exports